module.exports = __webpack_public_path__ + "img/3-7.96d83c38.svg";